export const MINI_ROW_HEIGHT = 37;
export const ROW_HEIGHT = 30;
export const LINE_HEIGHT = 13.5;
export const HEADER_COL_HEIGHT = 24;
